// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 229) return "static/chunks/229-24147dc042ef1e4b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"38":"7d408db7c9e183ba","579":"72d2ac25c3bb3d97","611":"084a2a177ee6ddf7","920":"ddb34be47912339e"}[chunkId] + ".js";
};